import React from 'react';

export const Fallback403: React.CSSProperties = {
	display: 'block',
	padding: '48px 32px',
};

export const Fallback403__Image: React.CSSProperties = {
	width: '250px',
	height: '295px',
	margin: '0 auto 24px auto',
	textAlignLast: 'center',
};

export const Fallback403__Title: React.CSSProperties = {
	color: 'rgba(0, 0, 0, 0.85)',
	fontSize: '24px',
	lineHeight: '1.8',
	textAlignLast: 'center',
	margin: '0',
};

export const Fallback403__Subtitle: React.CSSProperties = {
	color: 'rgba(0, 0, 0, 0.45)',
	fontSize: '14px',
	lineHeight: '1.6',
	textAlignLast: 'center',
};
